import { faEllipsisVertical } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React from "react";
import Dropdown from "react-bootstrap/Dropdown";
import ReactDOM from "react-dom";
import { IPagedListAction } from "../Declarations";

function isActionVisible(action: IPagedListAction, item: Record<string, unknown>): boolean {
    if (action.hideWhenMember && item[action.hideWhenMember]) {
        return false;
    }
    if (!action.availableMember) return true;
    return item[action.availableMember] === !action.availableFliped;
}

type Props = {
    id: string;
    ariaLabel: string;
    actions: IPagedListAction[];
    item: Record<string, unknown>;
    /** When true, renders the menu in a portal (avoids table overflow clipping). */
    usePortal?: boolean;
    className?: string;
};

const EllipsisActionMenu: React.FC<Props> = ({
    id,
    ariaLabel,
    actions,
    item,
    usePortal = false,
    className,
}) => {
    const visibleActions = actions.filter((action) => isActionVisible(action, item));
    if (visibleActions.length === 0) return null;

    const menu = (
        <Dropdown.Menu className="ellipsis-menu">
            {visibleActions.map((action) => (
                <React.Fragment key={action.text}>
                    {action.startGroup === true && <Dropdown.Divider />}
                    <Dropdown.Item
                        as="button"
                        type="button"
                        className={`d-flex align-items-center gap-2${action.itemClassName ? ` ${action.itemClassName}` : ""}`}
                        onClick={() => action.onClick(item)}
                    >
                        {action.icon && (
                            <FontAwesomeIcon icon={action.icon} fixedWidth aria-hidden />
                        )}
                        {action.text}
                    </Dropdown.Item>
                </React.Fragment>
            ))}
        </Dropdown.Menu>
    );

    return (
        <Dropdown align="end" className={className}>
            <Dropdown.Toggle
                variant="outline-secondary"
                id={id}
                className="ellipsis-menu-toggle border-0 py-2 px-2"
                aria-label={ariaLabel}
            >
                <FontAwesomeIcon icon={faEllipsisVertical} />
            </Dropdown.Toggle>
            {usePortal ? ReactDOM.createPortal(menu, document.body) : menu}
        </Dropdown>
    );
};

export { EllipsisActionMenu, isActionVisible };
